import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';

export const PriceButton = ({ id, children, primary = false, ...props }) => (
  <Button type="button" data-testid={id} variant={primary ? 'default' : 'outline'}
    className={`pl-button ${primary ? 'pl-primary' : ''}`} {...props}>{children}</Button>
);

export const PriceField = ({ id, label, value, onChange, multiline = false, children, ...props }) => {
  const shared = { id, 'data-testid': id, value: value ?? '', onChange: e => onChange(e.target.value), ...props };
  return <label className="pl-field" htmlFor={id}><span>{label}</span>
    {children ? <select {...shared}>{children}</select> : multiline ? <textarea rows={3} {...shared} /> : <input {...shared} />}
  </label>;
};

export const PriceToggle = ({ id, label, checked, onChange, disabled = false }) => (
  <label className="pl-toggle" htmlFor={id}><Switch id={id} data-testid={id} checked={!!checked} onCheckedChange={onChange} disabled={disabled} /><span>{label}</span></label>
);

export const cleanOverride = (value) => Object.fromEntries(Object.entries(value || {}).filter(([k, v]) => v !== null || k === 'flyer_price'));
export const priceText = (price) => price === null || price === undefined ? '—' : `${Number(price).toLocaleString('de-DE', { maximumFractionDigits: 2 })} €`;